import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { GetCityQuery, GetLocationsQuery, GetStateQuery } from '@app/graphql/cms/schema'

import { LocationsState } from './types'

const INITIAL_STATE: LocationsState = {
  locationsStatus: 'initial',
  stateStatus: 'initial',
  cityStatus: 'initial'
}

export const slice = createSlice({
  name: 'locations',
  initialState: INITIAL_STATE,

  reducers: {
    requestFetchLocations: state => {
      state.locationsStatus = 'pending'
    },
    requestFetchState: state => {
      state.stateStatus = 'pending'
    },
    requestFetchCity: state => {
      state.cityStatus = 'pending'
    },
    requestFetchLocationsError: (state, action: PayloadAction<string>) => {
      state.locationsStatus = 'failure'
      state.error = action.payload
    },
    requestFetchStateError: (state, action: PayloadAction<string>) => {
      state.stateStatus = 'failure'
      state.error = action.payload
    },
    requestFetchCityError: (state, action: PayloadAction<string>) => {
      state.cityStatus = 'failure'
      state.error = action.payload
    },
    successFetchLocations: (state, action: PayloadAction<GetLocationsQuery['states']>) => {
      state.locationsStatus = 'success'
      state.list = action.payload
    },
    successFetchCity: (state, action: PayloadAction<GetCityQuery['city']>) => {
      state.cityStatus = 'success'
      state.selectedCity = action.payload
    },
    successFetchState: (state, action: PayloadAction<GetStateQuery['state']>) => {
      state.stateStatus = 'success'
      state.selectedState = action.payload
    },
    resetFetchStatus: state => {
      state.locationsStatus = INITIAL_STATE.locationsStatus
      state.stateStatus = INITIAL_STATE.stateStatus
      state.cityStatus = INITIAL_STATE.cityStatus
    }
  }
})

export const { actions } = slice

export const locationsReducer = slice.reducer
